"use strict";

exports.__esModule = true;
exports.getDeviceDataItemStats = getDeviceDataItemStats;
var _getDeviceDataItems = require("./getDeviceDataItems");
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Given a list of devices, return an array of statistics for each named
 * data item in the list.
 */
function getDeviceDataItemStats(devices, allowedCategories, ignoredCategories) {
  var counts = new Map();
  devices == null || devices.forEach(function (device) {
    var items = (0, _getDeviceDataItems.getDeviceDataItems)(device);
    for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
      var dataItem = _step.value;
      if (!dataItem.name) {
        continue;
      }
      if (Array.isArray(allowedCategories) && !allowedCategories.includes(dataItem.category.toUpperCase())) {
        continue;
      }
      if (Array.isArray(ignoredCategories) && ignoredCategories.includes(dataItem.category.toUpperCase())) {
        continue;
      }
      var existing = counts.get(dataItem.name);
      if (existing !== undefined) {
        counts.set(dataItem.name, existing + 1);
      } else {
        counts.set(dataItem.name, 1);
      }
    }
  });
  var sortedKeys = Array.from(counts.keys()).sort();
  return sortedKeys.map(function (dataItemName) {
    return {
      dataItemName: dataItemName,
      deviceCount: counts.get(dataItemName) || 1
    };
  });
}